import { Typography } from "@mui/material";

export function Unauthorized() {
  return (
    <Typography variant="h5" fontWeight="bold" color="error">
      Unauthorized, You don't have permission for accessing this page !
    </Typography>
  );
}
